import React from 'react';
import styles from './CategoryHeader.module.scss';

const CategoryHeader = ({ title }) => {
  return (
    <div className={styles.wrapper}>
      <span>{title}</span>
    </div>
  );
};

export default CategoryHeader;
